import React from 'react'
import { useParams } from 'react-router-dom'
import getColorOverride from '../../utilities/functions'

const PartyCard = (props) => {
    const {prov, year} = useParams()
    const color = getColorOverride(props.party.nameShort, `${prov}_${year}`)
    return (
        <div 
            className={'max-h-9 text rounded p-1 flex gap-2 justify-between font-bold '} 
            style={{
                backgroundColor: color ? color.color : props.party.color,
                color: color ? color.font : 'white'
            }}
            aria-label={`${props.party.nameShort} ${props.result}`} >
            <div>{props.party.nameShort}</div>
            <div>{props.result > 0 && '+'}{props.result}</div>
        </div>
    )
}

export default PartyCard